import script from "./commission-info.vue?vue&type=script&setup=true&lang=js"
export * from "./commission-info.vue?vue&type=script&setup=true&lang=js"

import "./commission-info.vue?vue&type=style&index=0&id=0ae6f56b&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae6f56b"]])

export default __exports__